var HTTPS_RESOURCE_PATTERN = /^https:\/\//;

function isHttpsResource(uri) {
  return HTTPS_RESOURCE_PATTERN.test(uri);
}

module.exports = isHttpsResource;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/utils/is-https-resource.js
// module id = 1043
// module chunks = 0